module.exports = __webpack_public_path__ + "static/img/20.aee59b2.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/2/eng/20.png
// module id = WRCd
// module chunks = 0